var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input',{attrs:{"size":_vm.size,"value":_vm.userName,"readonly":"readonly","suffix-icon":"el-icon-user"}})}
var staticRenderFns = []

export { render, staticRenderFns }